export default __webpack_public_path__ + "static/3-69ed6db72a96681b4fc327cc22b12261.png";